import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { EntitiesProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { ENTITIES_PROJECTS } from "../../utils/constants";

export const createEntitiesProject = async (data: EntitiesProjectType) => await post<EntitiesProjectType, string>(ENTITIES_PROJECTS, data);
export const updateEntitiesProject = async (data: EntitiesProjectType) => await put<EntitiesProjectType, string>(ENTITIES_PROJECTS, data);

export const getEntitiesProject = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdEntity ? { IdEntity: data.IdEntity } : {}),
        ...(data?.IdProject ? { IdProject: data.IdProject } : {}),

    });
    const url = `${ENTITIES_PROJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<EntitiesProjectType>>(url);
};
